<template>
    <v-avatar :size="size" :color="color" class="tier-badge" :style="fontStyle">
        {{ tier }}
    </v-avatar>
</template>

<script setup>
    import {computed} from "vue";

    const props = defineProps({
        tier: {
            type: Number,
            required: true,
        },
        size: {
            type: Number,
            default: 28,
        },
        color: {
            type: String,
            default: "info",
        },
    });

    const fontStyle = computed(() => ({
        fontSize: `${props.size * 0.4}px`,
        fontWeight: 700,
        fontFamily: "'Michroma', sans-serif",
    }));
</script>

<style scoped>
    .tier-badge {
        font-family: 'Michroma', sans-serif !important;
        font-weight: 600 !important;
        color: rgba(var(--v-border-color));
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
    }
</style>
